import { render, staticRenderFns } from "./ReservationStatusPage.vue?vue&type=template&id=4751f747"
import script from "./ReservationStatusPage.vue?vue&type=script&lang=js"
export * from "./ReservationStatusPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports